export function setUnidades(state, unidades) {
    state.unidadesDeMedida = unidades.listas;
}
